import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  Box,
  Grid,
} from "@mui/material";

import { PreviewIndicator } from "./panelIndicators/PreviewIndicator";
import { AddIndicator } from "./panelIndicators/AddIndicator";
import { EditIndicator } from "./panelIndicators/EditIndicator";
import { DeleteIndicator } from "./panelIndicators/DeleteIndicator";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { useStyles } from "../../styles/Styles";
import { useFetchSections } from "../../hooks/useGetSections";
import { useFetchIndicators } from "../../hooks/useGetIndicators";
import { Loading } from "../sharedComponents/Loading";
import { DataNotFound } from "../sharedComponents/DataNotFound";

export const IndicatorPanel = ({ token, date, idDocument }) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [selectedIdIndicator, setSelectedIdIndicator] = useState(null);
  const [modalAdd, setOpenAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectedIdSection, setSelectedIdSection] = useState('');
  const { sections, loadingSection } = useFetchSections(token, idDocument);
  const { datos, loading } = useFetchIndicators(token, selectedDate, idDocument, refresh);
  const classes = useStyles();

  useEffect(() => {
    if (sections.length > 0 && !selectedIdSection) {
      setSelectedIdSection(sections[0]?.ID_SECCION);
    }
  }, [sections, selectedIdSection]);

  const filteredData = datos.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Paper elevation={0}>
        {loadingSection ? (
          <Loading />
        ) : (
          <>
            <Box sx={{ height: "auto", margin: "0 5px 15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={7}>
                  <TextField
                    label="Buscar indicadores por título"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    label="Fecha"
                    type="date"
                    variant="outlined"
                    value={selectedDate}
                    onChange={(event) => setSelectedDate(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenAdd(true)}
                    fullWidth
                    sx={{ height: "100%", borderRadius: "12px" }}
                  >
                    Agregar Indicador
                  </Button>
                </Grid>
              </Grid>
            </Box>
            {loading ? (
              <Loading message="Cargando Indicadores..." />
            ) : filteredData.length === 0 ? (
              <DataNotFound />
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={classes.tableTitle}>Título</TableCell>
                    <TableCell style={classes.tableTitle}>Indicador</TableCell>
                    <TableCell style={classes.tableTitle}>Sección</TableCell>
                    <TableCell style={classes.tableTitle}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() => {
                            setSelectedIndicator(item);
                            setModalPreviewOpen(true);
                          }}
                          style={{ borderRadius: "12px" }}
                        >
                          <img
                            src={item.imagen}
                            alt={item.title}
                            style={{ width: "80px", height: "50px", objectFit: "cover" }}
                          />
                        </Button>
                      </TableCell>
                      <TableCell>{item.nombre_seccion}</TableCell>
                      <TableCell>
                        <BorderColorIcon
                          onClick={() => {
                            setSelectedIndicator(item);
                            setModalEdit(true);
                          }}
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        />
                        <DeleteIcon
                          onClick={() => {
                            setSelectedIdIndicator(item.id);
                            setModalDelete(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </>
        )}
      </Paper>
      
      <PreviewIndicator
        open={modalPreviewOpen}
        close={() => setModalPreviewOpen(false)}
        indicator={selectedIndicator}
      />
      <AddIndicator
        token={token}
        open={modalAdd}
        close={() => setOpenAdd(false)}
        selectedDate={selectedDate}
        idDocument={idDocument}
        selectedIdSection={selectedIdSection}
        sections={sections}
        refresh={() => setRefresh(!refresh)}
      />
      <EditIndicator
        token={token}
        open={modalEdit}
        close={() => setModalEdit(false)}
        indicator={selectedIndicator}
        selectedDate={selectedDate}
        selectedIdSection={selectedIdSection}
        sections={sections}
        refresh={() => setRefresh(!refresh)}
      />
      <DeleteIndicator
        token={token}
        open={modalDelete}
        close={() => setModalDelete(false)}
        IdIndicator={selectedIdIndicator}
        refresh={() => setRefresh(!refresh)}
      />
    </>
  );
};
